import { TemplateListPageProps } from '@backstage/plugin-scaffolder/alpha';
import { NavigateFunction } from 'react-router-dom';

type RouteLink = () => string;

export const buildScaffolderPageContextMenuProps = (
  contextMenu: TemplateListPageProps['contextMenu'],
  navigate: NavigateFunction,
  routes: {
    editor: RouteLink;
    actions: RouteLink;
    tasks: RouteLink;
    templatingExtensions: RouteLink;
  },
) => ({
  onEditorClicked:
    contextMenu?.editor !== false
      ? () => navigate(routes.editor())
      : undefined,
  onActionsClicked:
    contextMenu?.actions !== false
      ? () => navigate(routes.actions())
      : undefined,
  onTasksClicked:
    contextMenu?.tasks !== false ? () => navigate(routes.tasks()) : undefined,
  onTemplatingExtensionsClicked:
    contextMenu?.templatingExtensions !== false
      ? () => navigate(routes.templatingExtensions())
      : undefined,
});
